import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  container: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100vw',
    height: '100vh',
    composes: 'cursor-wait',
    zIndex: 9999999,
  },
});

interface Props {
  pending: boolean;
}

const OperationProgressNotification = ({
  pending,
}: Props): React.JSX.Element | null => {
  const classes = useStyles();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (pending) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.addEventListener('keydown', handleKeyDown, true);
    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [pending]);

  return pending ? <div className={classes.container} /> : null;
};

export default OperationProgressNotification;
